import { Container } from 'inversify'
import { GeoLocationService } from './GeoLocationService'

export const SERVICES = {
  GeoLocationService: Symbol.for('GeoLocationService'),
}

export function registerBinding(container: Container): void {
  container.bind<GeoLocationService>(SERVICES.GeoLocationService).to(GeoLocationService)
}

//  DON'T DELETE - used by DW
